module.exports = __webpack_public_path__ + "img/meetingRoom.5c141d84.png";